import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AiVideoExtenderJsonLd } from '@/components/custom/ai-video-extender-json-ld';
import { AiVideoExtenderPage } from '@/components/custom/ai-video-extender-page';
import { getAiVideoExtenderSeoData } from '@/components/custom/ai-video-extender-seo-data';
import { seo } from '@/lib/seo';

const searchSchema = z.object({
  sourceVideoId: z.string().min(1).optional(),
});

export const Route = createFileRoute('/ai-video-extender')({
  validateSearch: searchSchema,
  head: () => {
    const data = getAiVideoExtenderSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
    });
  },
  component: AiVideoExtenderRoute,
});

function AiVideoExtenderRoute() {
  const search = Route.useSearch();

  return (
    <>
      <AiVideoExtenderPage initialSourceVideoId={search.sourceVideoId} />
      <AiVideoExtenderJsonLd />
    </>
  );
}
